/**
 * functions common language
 *
 * @category   Javascript
 * @author     Jakob Ohlsen <jakob.ohlsen@gmail.com>
 * @copyright  2025 Jakob Ohlsen
 */
// interface TextObject {
//     [key: string]: string | string[];
// }
// Module-scoped language state. Producers (page-defaults.ts and
// page-defaults-pdf.ts) call `setLanguage(...)` once at startup; consumers
// (`___`, `getLocale`, the four `toFixed*` helpers, request.ts) read from
// these vars. Decoupled from `window.lang` / `window.fallbackLang` so the
// API works in node tests, Web Workers, and any future SSR / Puppeteer
// context.
let currentLang = null;
let fallbackLang = null;
export function setLanguage(lang, fallback) {
    currentLang = lang;
    fallbackLang = fallback;
}
function isGerman() {
    return currentLang === 'de';
}
export function ___(text) {
    if (currentLang !== null && typeof text[currentLang] !== 'undefined')
        return text[currentLang];
    else if (fallbackLang !== null && typeof text[fallbackLang] !== 'undefined')
        return text[fallbackLang];
    else
        return '';
}
export function getLocale() {
    return currentLang ?? 'en';
}
export function toFixedNoTrailingZeros(x, digits) {
    if (isNaN(x))
        return x.toString();
    else if (isGerman())
        return x.toFixed(digits).replace(/\.?0+$/, '').replace('.', ',');
    else
        return x.toFixed(digits).replace(/\.?0+$/, '');
}
export function toFixedNumberStr(x, digits) {
    if (typeof x === 'undefined')
        return x;
    else if (isNaN(x))
        return x.toString();
    else if (isGerman())
        return Number(x).toFixed(digits).replace('.', ',');
    else
        return Number(x).toFixed(digits);
}
export function toFixedNumberStrWithFallback(x, digits, fallback = '-') {
    if (x === undefined || x === null || isNaN(x))
        return fallback;
    else if (isGerman())
        return Number(x).toFixed(digits).replace('.', ',');
    else
        return Number(x).toFixed(digits);
}
export function toNumberStr(x) {
    if (isNaN(x))
        return x.toString();
    else if (isGerman())
        return String(Number(x)).replace('.', ',');
    else
        return String(Number(x));
}
